module.exports = __webpack_public_path__ + "static/media/337.8c211417.png";